
import Vue from 'vue'
import { DatePicker } from '@/components/formGroups'
import { SchoolTermDto } from '@ViewModels/SchoolTermDto'
import * as TermUtils from '@/services/SchoolTermService'
import { ensureValueIsDate } from '@/services/DateHelpers'

export default Vue.extend({
   name: 'SchoolTerm',
   props: {
      index: Number,
      term: Object as () => SchoolTermDto,
      start: Date,
      end: Date,
   },
   computed: {
      userIsiUgoAdmin(): boolean {
         return this.$store.getters.userIsiUgoAdmin
      },

      startDay(): Date {
         const start = ensureValueIsDate(this.start)
         return TermUtils.addDays(start, -2)
      },
      endDay(): Date {
         const end = ensureValueIsDate(this.end)
         return TermUtils.addDays(end, 2)
      },
      daysBetween(): string {
         const days = TermUtils.termDuration(this.term)
         return isNaN(days) ? '-' : days.toString()
      },
      isInvalid(): boolean {
         const days = TermUtils.termDuration(this.term)
         return !isNaN(days) && days < 1
      },
   },
   methods: {
      setEnabled(isEnabled: boolean) {
         this.term.IsEnabled = isEnabled
         this.$emit('change')
      },
   },
   components: {
      DatePicker,
   },
})
